import React from 'react';
import { PageTitle } from '@gsa/afp-component-library';
import SolicitationNotification from '../utils/solicitation-notification';
import CreateSolicitationForm from './create-solicitation-form';
import UpiidDetailsFormContext from '../components/upiid-details/upiid-details-form-context';

const CreateSolicitationContent = () => {
  return (
    <div className="grid-col">
      <SolicitationNotification isModal={false} />
      <PageTitle title="New Solicitation" />
      <UpiidDetailsFormContext>
        <CreateSolicitationForm />
      </UpiidDetailsFormContext>
    </div>
  );
};

export default CreateSolicitationContent;
